
import AppSection from "./AppSection.vue"
import AppImage from "./AppImage.vue"

import stubDirectives from "../mixins/stubDirectives"

export default {
  components: {
    AppSection,
    AppImage
  },
  mixins: [stubDirectives],
  props: {
    listItems: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    spacious: {
      type: Boolean,
      default: false
    }
  }
}
